import Vue from 'vue'

var toNumber = function (value) {
  if (typeof value !== 'string') {
    return value
  } else {
    var parsed = Number(value)
    return isNaN(parsed)
      ? value
      : parsed
  }
}

Vue.mixin({
  methods: {
    limitBy: function (array, size, offset) {
      size = toNumber(size)
      offset = offset ? parseInt(offset, 10) : 0

      return typeof size === 'number' ? array.slice(offset, offset + size) : array
    }
  }
})



// WEBPACK FOOTER //
// ./src/mixins/limit-by.js